import React, { useEffect, useState } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import "./style.scss";
import { useDispatch, useSelector } from "react-redux";
import { requestPayouts } from "../../utils/apis/payments";
import { returnMessages } from "../../utils/store/reducers/Message";
import Spinner from "../../reusableComponents/spinner/Spinner";
import { returnErrors } from "../../utils/store/reducers/Error";
import customStyles from "../../customStyles";
import Select from "react-select";

const AffiliatePayout = ({ afspayoutList }) => {
  const { idToken } = useSelector((state) => state.auth);

  const [totalAmount, setTotalAmount] = useState(afspayoutList);
  useEffect(() => {
    setTotalAmount(afspayoutList);
  }, [afspayoutList]);
  const totalAmounts = totalAmount.reduce((acc, item) => acc + item.amount, 0);
  const commission = totalAmount.map((item) => item.id);
  const dispatch = useDispatch();
  const formik = useFormik({
    initialValues: {
      amount: totalAmounts,
      reason: "",
      login_id: null,
      payout_type: "AFS",
      method: "",
      commission: commission,
    },
    validationSchema: Yup.object({
      amount: Yup.number()
        .typeError("Withdraw amount must be a number")
        .required("Withdraw amount is required")
        .positive("Withdraw amount must be positive"),
      // available_amount: Yup.number()
      //   .typeError("Available amount must be a number")
      //   .required("Available amount is required")
      //   .positive("Available amount must be positive"),
      reason: Yup.string().required("Reason is required"),
      method: Yup.string().required("Payout method is required"),
    }),
    onSubmit: async (values, { setSubmitting }) => {
      try {
        // const formdata = createFormData(values);
        const response = await requestPayouts(idToken, values);
        if (response.status < 399) {
          dispatch(returnMessages(response.data.detail, 200));
        }
      } catch (err) {
        const error = err.response.data;
        if (Object.keys(error).length > 0) {
          const firstKey = Object.keys(error)[0];
          let firstString = error[firstKey];
          if (Array.isArray(firstString)) {
            firstString = firstString[0];
          }

          const msg = `${firstKey}: ${firstString}`;
          dispatch(returnErrors(msg, 400));
        }
        console.error("Error requesting payouts:", error);
      } finally {
        setSubmitting(false);
      }
    },
  });
  useEffect(() => {
    formik.setValues({
      amount: totalAmounts,
      commission: commission,
      payout_type: "AFS",
      method: "",
      reason: "",
    });
  }, [totalAmounts, totalAmounts]);
  return (
    <div className="affiliate_container">
      <form onSubmit={formik.handleSubmit}>
        <label htmlFor="amount" className="form_input_label">
          Withdraw Amount
          <input
            type="text"
            className="form_input_box"
            id="amount"
            name="amount"
            placeholder="0"
            disabled
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            value={formik.values.amount}
            // disabled
          />
          {formik.touched.amount && formik.errors.amount ? (
            <div className="error_message">{formik.errors.amount}</div>
          ) : null}
        </label>
        {/* <label htmlFor="available_amount" className="form_input_label">
          Available Amount
          <input
            type="text"
            className="form_input_box"
            id="available_amount"
            name="available_amount"
            placeholder="0"
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            value={formik.values.available_amount}
          />
          {formik.touched.available_amount && formik.errors.available_amount ? (
            <div className="error_message">
              {formik.errors.available_amount}
            </div>
          ) : null}
        </label> */}
        <label htmlFor="method" className="form_input_label">
          Payment Method
          <Select
            className="form_input_box react-select-container"
            classNamePrefix="react-select"
            name="method"
            placeholder="Select your Payment Method"
            styles={customStyles}
            id="method"
            isSearchable={true}
            options={[
              { label: "ACH", value: "ACH" },
              { label: "WIRE", value: "WIRE" },
              { label: "SWIFT", value: "SWIFT" },
              { label: "WISE", value: "WISE" },
              { label: "RISE", value: "RISE" },
            ]}
            onChange={(option) => formik.setFieldValue("method", option.value)}
            onBlur={formik.handleBlur}
          />
          {formik.touched.method && formik.errors.method ? (
            <div className="error_message">{formik.errors.method}</div>
          ) : null}
        </label>
        <label htmlFor="reason" className="form_input_label">
          Reason
          <input
            type="text"
            className="form_input_box"
            id="reason"
            name="reason"
            placeholder="Enter your reason"
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            value={formik.values.reason}
          />
          {formik.touched.reason && formik.errors.reason ? (
            <div className="error_message">{formik.errors.reason}</div>
          ) : null}
        </label>
        <button
          type="submit"
          disabled={formik.isSubmitting}
          className="standard-button"
        >
          {formik.isSubmitting ? <Spinner /> : "Submit"}
        </button>
      </form>
    </div>
  );
};

export default AffiliatePayout;
